import React from 'react';
import NoSSR from 'react-no-ssr';
import ChipEdit from 'ChipEdit';
import transform from '../../../common/transform';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from './header';
import Content from './content';
import BottomFooter from './bottomFooter';
import ToTop from '../../components/toTop';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        if (window && window.BJ_REPORT) {
            window.BJ_REPORT.firstScreen();
        }
    }

    render() {
        const { content } = this.props;
        const {
            search,
            footer,
            topAd,
            asideAd2,
            asideAd3,
            assess,
            commentAd,
            commentBottomAd,
            bottomAd,
            docData,
            type,
            hasCopyRight,
        } = content;

        const headerData = {
            search,
            topAd,
        };
        const contentData = {
            type,
            docData,
            asideAd2,
            asideAd3,
            assess,
            commentAd,
            commentBottomAd,
            hasCopyRight,
        };
        const footerData = {
            footer,
            bottomAd,
        };

        return (
            <div>
                <Header content={headerData} />
                <Content content={contentData} />
                <BottomFooter content={footerData} />
                <NoSSR>
                    <ToTop />
                </NoSSR>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
